module.exports = __webpack_public_path__ + "static/media/konux_logo.1cfc6765.svg";